<p>contractor-image-upload works!</p>
